import { render } from "./TagModalAddTag.vue?vue&type=template&id=708e3610&scoped=true"
import script from "./TagModalAddTag.vue?vue&type=script&lang=js"
export * from "./TagModalAddTag.vue?vue&type=script&lang=js"

import "./TagModalAddTag.vue?vue&type=style&index=0&id=708e3610&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708e3610"]])

export default __exports__